import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";

const galleryItems = [
    {
        src: "/assets/images/prod1.jpeg",
        category: "Products"
    },
    {
        src: "/assets/images/prod2.jpeg",
        category: "Products"
    },
    {
        src: "/assets/images/prod3.jpeg",
        category: "Products"
    },
    {
        src: "/assets/images/prod4.jpeg",
        category: "Products"
    },
    {
        src: "/assets/images/prod5.jpeg",
        category: "Products"
    },
    {
        src: "/assets/images/prod6.jpeg",
        category: "Products"
    }
];

export default function Gallery() {
    const [selectedImage, setSelectedImage] = useState(null);

    return (
        <section className="py-20 px-6 bg-gradient-to-b from-vsblack to-vsblackLight">
            <div className="max-w-7xl mx-auto">

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {galleryItems.map((item, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.9 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            whileHover={{ y: -8 }}
                            className="relative group cursor-pointer overflow-hidden rounded-xl shadow-dark"
                            onClick={() => setSelectedImage(item)}
                        >
                            {/* Image */}
                            <div className="relative h-64 overflow-hidden bg-vsblackLight">
                                <img
                                    src={item.src}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                />

                                {/* Overlay gradient */}
                                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-40 group-hover:opacity-60 transition-opacity duration-300" />

                                {/* Red glow effect on hover */}
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                                    <div className="absolute inset-0 shadow-red-glow" />
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>

            {/* Lightbox Modal */}
            <AnimatePresence>
                {selectedImage && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/95 backdrop-blur-md overflow-auto"
                        onClick={() => setSelectedImage(null)}
                    >
                        {/* Close Button */}
                        <motion.button
                            initial={{ scale: 0 }}
                            animate={{ scale: 1 }}
                            exit={{ scale: 0 }}
                            className="absolute top-6 right-6 w-12 h-12 bg-vsred/90 hover:bg-vsred rounded-full flex items-center justify-center text-white text-xl z-20"
                            onClick={() => setSelectedImage(null)}
                        >
                            <FaTimes />
                        </motion.button>

                        {/* Modal Content */}
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: 0.9, opacity: 0 }}
                            className="relative max-w-3xl w-full bg-vsblack rounded-xl shadow-lg p-4 flex flex-col items-center"
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* Image */}
                            <img
                                src={selectedImage.src}
                                alt={selectedImage.title}
                                className="w-full h-auto max-h-[50vh] object-contain rounded-xl"
                            />

                            {/* Title & Category */}
                            <div className="mt-4 text-center px-4">
                                <h3 className="text-2xl font-bold text-white font-serif mb-1">
                                    {selectedImage.title}
                                </h3>
                                <p className="text-gray-400">{selectedImage.category}</p>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}
